import React, { useState} from 'react';

import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import { useTranslation } from "react-i18next";

import { useNavigate } from 'react-router-dom';

//import axios from 'axios';
//import uuid from "uuid";

import * as Config from '../Config.js'; 
import TopAppBar from './TopAppBar' ;


function LoginScreen()  {
    const {t} = useTranslation() ;
    const [name, setName] = useState("") ;
    const [password, setPassword] = useState("") ;
    const [message, setMessage] = useState("") ;
    
    const navigate = useNavigate();
    
   
    
    const login = async () => {
        // console.log('login invoked' ) ;
        if (name.trim().length === 0) {
            setMessage(t("Please enter your name")) ;
            return ;
        }
        if (password.trim().length === 0) {
            setMessage(t("Please enter password")) ;
            return ;
        }

        const data = new FormData();
        data.append('name', name);
        data.append('passwd', password);

        console.log(`Api Url = ${Config.apiUrl}`) ;
        
        try {
            let response = await fetch(Config.apiUrl  + '/site/login', {
                method: 'POST',
                body: data,
                credentials: 'include',
            });
            let res = await response.json() ;
            // axios.post(Config.apiUrl + '/login', {name : name, passwd : password})
            console.log(res) ;
            if (res.success) {
                navigate('/');
            } else {
                setMessage(t(res.error)) ;
            }
        } catch (e) {
            setMessage(t("Probable permission error")) ;
        }    
    }
        
    return (
        <Container maxWidth="sm">
        <TopAppBar 
            title= {t("Log In")} 
            returnLink="/"
        />
        <Box
            component="form"
            sx={{
              '& .MuiTextField-root': { m: 1, width: '25ch' },
              'marginTop' : '10%'
            }}
            noValidate
            autoComplete="off"
        >
            <div>
                <TextField 
                    required
                    label={t("User Name")} 
                    variant="standard" 
                    onChange={(ev) => setName(ev.target.value)} 
                    autoFocus
                />
            </div>

            <div>
                <TextField 
                    required
                    label={t("Password")} 
                    variant="standard" 
                    type="password" 
                    onChange={(ev) => setPassword(ev.target.value)} 
                />
            </div>
            <Box
                  display="flex"
                  justifyContent="space-around"
                  alignItems= "center"
                  marginTop="5%"
                  marginBottom="5%"
                  
              >    
                <Button variant="outlined" onClick={ () => login()}>{t("Log In")}</Button>
            </Box>
            {message && 
                <Alert severity="error">{message}</Alert>
            }  
        </Box>    
        </Container>
    )   
}

export default LoginScreen ;